"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const use_query_params_1 = require("use-query-params");
const core_1 = require("@material-ui/core");
const lab_1 = require("@material-ui/lab");
const core_ui_1 = require("@sierralabs/core-ui");
const QueryGroupMenuButton_1 = __importDefault(require("../common/menus/QueryGroupMenuButton"));
const QueryMenuButton_1 = __importDefault(require("../common/menus/QueryMenuButton"));
const CreateQueryGroupDialog_1 = __importDefault(require("../dialogs/CreateQueryGroupDialog"));
const ImportQueryDialog_1 = __importDefault(require("../dialogs/ImportQueryDialog"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const QueryContext_1 = require("../QueryContext");
const StyledPanel = (0, styled_components_1.default)(core_ui_1.Panel) `
  .query-group {
    display: flex;
    align-items: center;
  }
  .deleted-item {
    color: red;
  }
  .more-icon {
    font-size: 18px;
  }
  .flex-end {
    flex: 1;
    display: flex;
    justify-content: flex-end;
    padding: 0 12px 0 6px;
  }
`;
const QueryListPanel = () => {
    const [queryId, setQueryId] = (0, use_query_params_1.useQueryParam)('queryId', use_query_params_1.StringParam);
    const [showDeleted, setShowDeleted] = (0, use_query_params_1.useQueryParam)('show-deleted', use_query_params_1.BooleanParam);
    const [successMessage, setSuccessMessage] = (0, react_1.useState)('');
    const [importQueryGroupId, setImportQueryGroupId] = (0, react_1.useState)();
    const [openCreateGroupDialog, setOpenCreateGroupDialog] = (0, react_1.useState)(false);
    const [menuAnchor, setMenuAnchor] = (0, react_1.useState)(null);
    const { queryManager, setQuery } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const { queries, queryGroups, getQueryGroups } = (0, QueryContext_1.useQueryContext)();
    (0, react_1.useEffect)(() => {
        getQueryGroups({ includeDeleted: showDeleted });
        setMenuAnchor(null);
    }, [getQueryGroups, showDeleted]);
    (0, react_1.useEffect)(() => {
        var _a;
        if ((_a = queryManager.query) === null || _a === void 0 ? void 0 : _a.id) {
            setQueryId(queryManager.query.id);
        }
    }, [queryManager, setQueryId]);
    (0, react_1.useEffect)(() => {
        if (queryId) {
            const query = queries.find(query => query.id === queryId);
            if (query) {
                setQuery(query);
            }
        }
    }, [queryId, queries, setQuery]);
    return (react_1.default.createElement(StyledPanel, { className: 'site-components' },
        react_1.default.createElement(core_ui_1.PanelHeader, { accessory: react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: e => setMenuAnchor(e.currentTarget) },
                react_1.default.createElement(core_1.Icon, { className: 'more-icon' }, "more_vert")) },
            react_1.default.createElement(core_1.Typography, { variant: 'overline' }, "Queries"),
            react_1.default.createElement(core_1.Menu, { id: 'query-more-menu', anchorEl: menuAnchor, keepMounted: true, open: Boolean(menuAnchor), getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => {
                    setMenuAnchor(null);
                } },
                react_1.default.createElement(core_1.MenuItem, { onClick: () => setOpenCreateGroupDialog(true) }, "Add Group"),
                react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                        showDeleted ? setShowDeleted(false) : setShowDeleted(true);
                    } }, showDeleted ? 'Hide Deleted' : 'Show Deleted'))),
        react_1.default.createElement(core_ui_1.PanelContent, null, queryGroups && (react_1.default.createElement(lab_1.TreeView, { defaultCollapseIcon: react_1.default.createElement(core_1.Icon, null, "arrow_drop_down"), defaultExpandIcon: react_1.default.createElement(core_1.Icon, null, "arrow_right") }, queryGroups.map(queryGroup => (react_1.default.createElement(lab_1.TreeItem, { key: queryGroup.name, nodeId: queryGroup.name, className: queryGroup.deleted ? 'deleted-item' : undefined, label: react_1.default.createElement("div", { className: 'query-group' },
                queryGroup.name,
                react_1.default.createElement("div", { className: 'flex-end' },
                    react_1.default.createElement(QueryGroupMenuButton_1.default, { queryGroup: queryGroup, onImportClick: () => {
                            setImportQueryGroupId(queryGroup.id);
                        } }))), onLabelClick: event => {
                event.preventDefault();
            } }, queryGroup.queries.map(query => (react_1.default.createElement(lab_1.TreeItem, { className: query.deleted ? 'deleted-item' : undefined, key: query.id, nodeId: query.id, label: react_1.default.createElement("div", { className: 'query-group' },
                query.name,
                react_1.default.createElement("div", { className: 'flex-end' },
                    react_1.default.createElement(QueryMenuButton_1.default, { query: query }))), onClick: () => setQuery(query) }))))))))),
        openCreateGroupDialog && (react_1.default.createElement(CreateQueryGroupDialog_1.default, { open: true, onCancel: () => setOpenCreateGroupDialog(false), onCreated: () => {
                getQueryGroups({ includeDeleted: showDeleted });
                setMenuAnchor(null);
                setOpenCreateGroupDialog(false);
            } })),
        importQueryGroupId && (react_1.default.createElement(ImportQueryDialog_1.default, { open: true, queryGroupId: importQueryGroupId, onCancel: () => setImportQueryGroupId(undefined), onImport: query => {
                getQueryGroups({ includeDeleted: showDeleted });
                setImportQueryGroupId(undefined);
                setSuccessMessage(`Imported "${query.name}" Query.`);
            } })),
        react_1.default.createElement(core_ui_1.AppSnackbar, { severity: 'success', open: !!successMessage, onClose: () => setSuccessMessage('') }, successMessage)));
};
exports.default = QueryListPanel;
//# sourceMappingURL=QueryListPanel.js.map